import { render } from "./EventHeader.vue?vue&type=template&id=7348197c"
import script from "./EventHeader.vue?vue&type=script&lang=js"
export * from "./EventHeader.vue?vue&type=script&lang=js"

import "./EventHeader.vue?vue&type=style&index=0&id=7348197c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__